import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

const API_URL_NEW = window.location.hostname === 'en-dxb.thwifty.com' ?
  'https://api-ae.amazinge.store' :
  process.env.REACT_APP_API_CONNECT

export const membershipApi = createApi({
  reducerPath: 'membershipApi',
  baseQuery: fetchBaseQuery({
    baseUrl: `${API_URL_NEW}/`,
  }),

  tagTypes: ['Membership'],
  refetchOnMountOrArgChange: 1,
  endpoints: (builder) => ({

    getOrder: builder.query({
      query: (data) => {
        return {
          url: `api/orders/${data.userId}?page=${data.page}&size=${data.size}`,
          method: 'GET',
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-Country-Code': data.countryCode,
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Membership'],
    }),

    showOrder: builder.query({
      query: (data) => {
        return {
          url: `api/orders/${data.userId}/${data.orderNumber}`,
          method: 'GET',
          headers: {
            'Access-Key': localStorage.getItem('accessKey'),
            'X-Country-Code': data.countryCode,
            'X-User-Token': data.userToken,
            'X-User-Id': data.userId,
            'Accept': 'application/json',
            'Content-Type': 'application/json',
          },
        }
      },
      // keepUnusedDataFor: 1,
      providesTags: ['Membership'],
    }),

  }),

})

export const { useGetOrderQuery, useShowOrderQuery } = membershipApi